import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EventSignificance from "../pages/EventSignificance";
import SponsorGuide from "../pages/SponsorGuide";
import News from "../pages/News";
import DonorStory from "../pages/DonorStory";
import AdminLayout from "../pages/admin/AdminLayout";
import AdminDashboard from "../pages/admin/AdminDashboard";
import LoginPage from "../pages/admin/LoginPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/event",
    element: <EventSignificance />,
  },
  {
    path: "/sponsor-guide",
    element: <SponsorGuide />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/donor-story",
    element: <DonorStory />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
    ],
  },
  {
    path: "/admin/login",
    element: <LoginPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
